// Static content for Money Mart landing page

export const CONTACT = {
  phone: "+91 92144 17434",
  phoneDigits: "919214417434",
  whatsapp: "919214417434",
  email: "contact@money-mart.in",
  address:
    "Money Mart, 1st A-B Rd, Opposite Gold Plaza, Sardarpura, Jodhpur, Rajasthan 342003",
  hours: "Mon – Sat, 10:00 AM – 7:00 PM",
  gst: "08ASLPS2597P1ZK",
  mapEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7154.909299051488!2d73.0048500274097!3d26.279357335823313!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39418c3156299a5d%3A0xe29a7c2041571762!2sMoney%20Mart!5e0!3m2!1sen!2sin!4v1785014514937!5m2!1sen!2sin",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Loan Solutions", href: "#loans" },
  { label: "Calculators", href: "#calculators" },
  { label: "Why Money Mart", href: "#why" },
  { label: "Our Process", href: "#process" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

// Public bank logos (Wikimedia/public sources) — cropped SVG/PNG
export const PARTNER_BANKS = [
  {
    name: "HDFC Bank",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/HDFC_Bank_Logo.svg/512px-HDFC_Bank_Logo.svg.png",
  },
  {
    name: "ICICI Bank",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/ICICI_Bank_Logo.svg/512px-ICICI_Bank_Logo.svg.png",
  },
  {
    name: "Axis Bank",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Axis_Bank_logo.svg/512px-Axis_Bank_logo.svg.png",
  },
  {
    name: "State Bank of India",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/SBI-logo.svg/512px-SBI-logo.svg.png",
  },
  {
    name: "Yes Bank",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/Yes_Bank_SVG_Logo.svg/512px-Yes_Bank_SVG_Logo.svg.png",
  },
  {
    name: "Kotak Mahindra Bank",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0c/Kotak_Mahindra_Bank_logo.svg/512px-Kotak_Mahindra_Bank_logo.svg.png",
  },
  {
    name: "Punjab National Bank",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7c/Punjab_National_Bank_logo.svg/512px-Punjab_National_Bank_logo.svg.png",
  },
  {
    name: "Bank of Baroda",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Bank_of_Baroda_logo.svg/512px-Bank_of_Baroda_logo.svg.png",
  },
  {
    name: "IDFC FIRST Bank",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/IDFC_First_Bank_logo.svg/512px-IDFC_First_Bank_logo.svg.png",
  },
  {
    name: "AU Small Finance Bank",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/eb/AU_Small_Finance_Bank_logo.svg/512px-AU_Small_Finance_Bank_logo.svg.png",
  },
  {
    name: "Federal Bank",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4d/Federal_Bank_logo.svg/512px-Federal_Bank_logo.svg.png",
  },
  {
    name: "Union Bank of India",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Union_Bank_of_India_logo.svg/512px-Union_Bank_of_India_logo.svg.png",
  },
];

export const LOAN_CATEGORIES = [
  {
    icon: "Home",
    title: "Home Loan",
    desc: "Financing options for buying, building or renovating your home through partner banks.",
    suitable: "First-time buyers · Resale · Under-construction",
    type: "Secured",
    url: "/home-loan",
  },

  {
    icon: "Landmark",
    title: "Loan Against Property (LAP)",
    desc: "Unlock value from residential or commercial property with structured LAP solutions.",
    suitable: "Self-employed · Business expansion · Personal needs",
    type: "Secured",
    url: "/loan-against-property",
  },
  {
    icon: "Building2",
    title: "Mortgage Loan",
    desc: "Unlock value from residential or commercial property with structured mortgage solutions.",
    suitable: "Self-employed · Business expansion · Personal needs",
    type: "Secured",
    url: "/mortgage-loan",
  },
  {
    icon: "Building2",
    title: "Commercial Purchase Loan",
    desc: "Financing for purchase of shops, offices and commercial spaces.",
    suitable: "Investors · Business owners · Professionals",
    type: "Secured",
    url: "/commercial-purchase-loan",
  },
  {
    icon: "HardHat",
    title: "Construction Loan",
    desc: "Stage-wise disbursal for construction on owned residential or commercial plots.",
    suitable: "Plot owners · Builders · Self-construction",
    type: "Secured",
    url: "/construction-loan",
  },
  {
    icon: "CreditCard",
    title: "OD / Dropline OD",
    desc: "Overdraft facilities including dropline OD with flexible utilisation.",
    suitable: "Business and Personal needs",
    type: "Secured",
    url: "/overdraft-dropline-od",
  },
  {
    icon: "Coins",
    title: "CC Limit",
    desc: "Cash Credit facilities to finance inventory, receivables and day-to-day business operations.",
    suitable: "Manufacturers · Traders · MSMEs",
    type: "Secured",
    url: "/cc-limit",
  },
  {
    icon: "GraduationCap",
    title: "LRD Program",
    desc: "Specialized lending solutions designed for eligible professionals under lender-specific LRD programs.",
    suitable: "Professionals · High-income Individuals",
    type: "Secured",
    url: "/lrd-program",
  },
  {
    icon: "Repeat",
    title: "Takeover + Top-Up",
    desc: "Transfer existing loans to lower-rate partner banks and access additional funds.",
    suitable: "Existing loan borrowers",
    type: "Secured",
    url: "/takeover-top-up",
  },
  {
    icon: "Wallet",
    title: "Wealth Based Loan",
    desc: "Access financing based on the value of your eligible wealth and assets.",
    suitable: "High-Asset Individuals · Investors · Business Owners",
    type: "Secured",
    url: "/wealth-based-loan",
  },
  {
    icon: "Briefcase",
    title: "Business Loan",
    desc: "Unsecured business finance to support working capital, expansion and growth needs.",
    suitable: "MSMEs · Established businesses · Traders",
    type: "Unsecured",
    url: "/business-loan",
  },
  {
    icon: "Car",
    title: "Car Loan",
    desc: "Finance new and used cars with competitive interest rates and flexible repayment options.",
    suitable: "Salaried · Self-employed · Business owners",
    type: "Unsecured",
    url: "/car-loan",
  },
  {
    icon: "UserRound",
    title: "Personal Loan",
    desc: "Unsecured personal loans for medical expenses, travel, education, weddings and other personal needs.",
    suitable: "Salaried · Self-employed Professionals",
    type: "Unsecured",
    url: "/personal-loan",
  },
];

export const WHY_CHOOSE = [
  {
    icon: "FileSignature",
    title: "One Application",
    desc: "A single, structured enquiry gives you access to multiple lending partners at once.",
  },
  {
    icon: "FolderCheck",
    title: "Documentation Assistance",
    desc: "Dedicated support from our team throughout the application and file preparation.",
  },
  {
    icon: "ScanSearch",
    title: "Policy Matching",
    desc: "We help identify lenders whose criteria best match your profile and requirement.",
  },
  {
    icon: "GraduationCap",
    title: "Experienced Advisors",
    desc: "Advisors with deep banking expertise across secured and unsecured products.",
  },
  {
    icon: "ShieldCheck",
    title: "Transparent Process",
    desc: "Clear communication on process, fees and lender requirements — no hidden surprises.",
  },
  {
    icon: "UserCheck",
    title: "Dedicated Relationship Manager",
    desc: "Personalised guidance from initial enquiry through to lender decision.",
  },
];

export const PROCESS_STEPS = [
  {
    title: "Submit Enquiry",
    desc: "Share your requirement and basic details through our eligibility form.",
  },
  {
    title: "Profile Assessment",
    desc: "Our advisor reviews your profile against multiple partner-lender policies.",
  },
  {
    title: "Compare Suitable Lenders",
    desc: "We shortlist banks/NBFCs whose criteria align with your requirement.",
  },
  {
    title: "Documentation Support",
    desc: "We help you compile and structure the file for the chosen lender.",
  },
  {
    title: "Application Submission",
    desc: "Your application is submitted to the selected lending partner(s).",
  },
  {
    title: "Decision by Lending Institution",
    desc: "The bank or NBFC evaluates and communicates its decision as per its policy.",
  },
  {
    title: "Loan Disbursal (if approved)",
    desc: "On approval and formalities, the lender disburses the loan directly to you.",
  },
];

export const STATS = [
  { value: 30, suffix: "+", label: "Partner Banks & NBFCs" },
  { value: 1000, prefix: "₹", suffix: " Cr+", label: "Loans Facilitated" },
  { value: 95, suffix: "%", label: "Processing Success Rate*" },
  { value: 20, suffix: "+ Yrs", label: "Advisory Experience" },
];

export const BECOME_DSA_POINTS = [
  {
    title: "Work with leading lenders",
    description: "Get access to loan products from multiple banks and NBFCs.",
  },
  {
    title: "Earn through successful disbursals",
    description:
      "Build an additional income stream through loan referrals and successful disbursals.",
  },
  {
    title: "Get professional support",
    description:
      "Money Mart's team can support you through the loan facilitation process.",
  },
  {
    title: "Build a long-term career",
    description:
      "Develop your network, financial-services knowledge and customer base over time.",
  },
  {
    title: "No Upfront Charges",
    description:
      "Get started with Money Mart at no upfront cost. There are no joining or registration fees to become a DSA.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Rohan Malhotra",
    city: "Bengaluru",
    rating: 5,
    text: "The Money Mart advisor understood my self-employed profile and helped us identify a bank that matched our criteria. Documentation support saved us weeks of back-and-forth.",
  },
  {
    name: "Priya Nair",
    city: "Mumbai",
    rating: 5,
    text: "Very transparent conversations from day one. They compared options across multiple banks and walked us through fees clearly before we made a choice.",
  },
  {
    name: "Arjun Reddy",
    city: "Hyderabad",
    rating: 5,
    text: "Our LAP file was structured properly and the RM stayed with us till disbursal. Professional experience and nothing feels rushed or salesy.",
  },
  {
    name: "Meera Iyer",
    city: "Chennai",
    rating: 5,
    text: "Straightforward eligibility check and honest guidance. They didn't overpromise and explained that approval depends on the bank's own policy.",
  },
  {
    name: "Karan Shah",
    city: "Ahmedabad",
    rating: 5,
    text: "Refinanced our business OD at a much better rate through their takeover process. Neat, clean and no hidden surprises.",
  },
  {
    name: "Sneha Kulkarni",
    city: "Pune",
    rating: 5,
    text: "Loved the calm, consultative approach. Feels more like a financial advisor than a call centre pushing loans.",
  },
];

export const AWARDS = [
  {
    // year: "",
    title: "Mega Star Award",
    by: "ICICI BANK",
    desc: "Recognition for sustained contribution and quality of files submitted.",
  },
  {
    // year: "2023",
    title: "Award of Excellence",
    by: "AXIS BANK MAX LIFE",
    desc: "Awarded for consistent performance across mortgage products.",
  },
  {
    // year: "2022",
    title: "Outstanding Contribution",
    by: "IDBI BANK",
    desc: "For outstanding contribution to the retail secured lending segment.",
  },
  {
    // year: "2021",
    title: "Best Performance Award",
    by: "AXIS BANK TATA AIG",
    desc: "Recognition for performance in home loan facilitation.",
  },
  {
    // year: "2020",
    title: "Star Performer",
    by: "AXIS BANK",
    desc: "Star Performer recognition across secured lending products.",
  },
  {
    // year: "2020",
    title: "Most systematic processing champion",
    by: "ICICI BANK",
    desc: "Recognized for delivering highly organized and error-free loan processing.",
  },
];

export const FAQS = [
  {
    q: "Is Money Mart a bank?",
    a: "No. Money Mart is a Bank Channel Partner (DSA). We help you compare loan options and manage the application process. All loan decisions are made solely by RBI-regulated Banks and NBFCs.",
  },
  {
    q: "Who approves my loan?",
    a: "The respective Bank or NBFC approves your loan based on their internal credit policies, your profile and applicable regulations. Money Mart facilitates the process but does not approve loans.",
  },
  {
    q: "Does Money Mart charge hidden fees?",
    a: "No. We follow a transparent fee policy and any applicable service fee is disclosed upfront in writing before you proceed. All bank/NBFC charges are as per the respective lender's schedule.",
  },
  {
    q: "Can I apply if I'm self-employed?",
    a: "Yes. We work with lenders that cater to salaried, self-employed professionals and business owners. The suitable lender depends on your profile, income proof and product.",
  },
  {
    q: "How long does the process take?",
    a: "Timelines vary by lender, loan type, applicant profile and completeness of documentation. Our advisor will share indicative timelines based on your specific case.",
  },
  {
    q: "Will checking eligibility affect my credit score?",
    a: "A basic eligibility discussion with our advisor does not affect your credit score. A formal credit bureau enquiry only happens when the lender initiates it during application, with your consent.",
  },
];

export const TRUST_CARDS = [
  { label: "Partner Banks", value: "30+" },
  { label: "Facilitated", value: "₹800 Cr+" },
  { label: "Processing Success*", value: "95%" },
  { label: "Experience", value: "20+ Yrs" },
];

export const INDIAN_STATES = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Puducherry",
  "Chandigarh",
  "Andaman and Nicobar Islands",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Lakshadweep",
];
